import axios from 'axios';
import * as Logger from '../../logger';
import { getOptimizelyCohorts, getOptimizelyEndUserId, getOptimizelySegments } from '../../optimizelyHelpers';
import Constants from '../constants';

class GASv2 {
  hasShownWarning: boolean;
  
  constructor() {
    this.hasShownWarning = false;
  }

  track(postBody: any) {
    if (!this.hasShownWarning) {
      this.hasShownWarning = true;
      Logger.warn('GASv2 is deprecated! Please migrate to GASv3 when possible.');
    }

    let options = {
      headers: {
        'content-type': 'application/json'
      },
      withCredentials: true
    };

    postBody['properties']['optimizelyCohorts'] = getOptimizelyCohorts();
    postBody['properties']['optimizelySegments'] = getOptimizelySegments();
    postBody['properties']['optimizelyEndUserId'] = getOptimizelyEndUserId();

    return axios.post(Constants.urls.gasv2Url, postBody, options)
      .then(d => {
        return d;
      })
      .catch(e => {
        return Promise.reject(e);
      });
  }
}

export { GASv2 };

export default new GASv2();
